import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {  useSelector } from 'react-redux';

const HeaderNavBar = ({ selectedReport }) => {

  const client = useSelector(state => state.client );

  const firstToSelectPage =  useSelector(state => state.auth.firstToSelectPage);
  const clientProps = useSelector(state => state.client.props);
  const lastInsightPage = useSelector(state => state.route.lastInsightPage);
  const lastAudienceBuilderPage = useSelector(state => state.route.lastAudienceBuilderPage);
  const lastCampaignSummaryPage = useSelector(state => state.route.lastCampaignSummaryPage);

  let openBuild;
  if(clientProps) {
    openBuild = clientProps.enableAudienceBuilder
  }

  const reportLinks = [
    // {
    //   id: 'homepage',
    //   name: 'HOME',
    //   path:  '/',
    //   suitablePaths: ['/'],
    //   available: client.accountType === 'collects' &&
    //   firstToSelectPage === false &&
    //   client.showHomePage === true,
    // },
    // {
    //   id: 'insight',
    //   name: 'INSIGHTS',
    //   path: lastInsightPage || '/insight-landing',
    //   suitablePaths: ['/insight-landing','/home-insights','/work-insights','/footfall-insights','/mobile-device-insights','/brand-affinity-insights','/travelling-past-insights'],
    //   available: firstToSelectPage === false && client.accountType === 'collects',
    // },
    // {
    //   id: 'audience-builder',
    //   name: 'BUILD',
    //   path: lastAudienceBuilderPage || '/audience-builder-select-type',
    //   suitablePaths: ['/audience-builder-select-type','/audience-builder'],
    //   available: firstToSelectPage === false && client.accountType === 'collects' && openBuild === true,
    // },
    // {
    //   id: 'campaign-summary',
    //   name: 'CAMPAIGN',
    //   path: lastCampaignSummaryPage || '/campaign-summary',
    //   suitablePaths: ['/campaign-summary'],
    //   available: clientProps && clientProps.enableAudienceSummary === true,
    // },
  ];

  return (
    <nav className="InsightsNavBar">
      <ul className="InsightsNavBar_ul">
        {reportLinks.map(report => (
          <li className="InsightsNavBar_li" key={report.id}>
            {report.available === true && report.path ? (
              <React.Fragment>
                  <Link
                    to={report.path}
                    className={`InsightsNavBar_link${
                      report.suitablePaths.indexOf(window.location.pathname) > -1
                        ? ' InsightsNavBar_link_selected'
                        : ''
                    }`}
                  >
                    {report.name}
                  </Link>

              </React.Fragment>
            ) : (
              <div />
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

HeaderNavBar.propTypes = {
  selectedReport: PropTypes.string.isRequired,
};

export default HeaderNavBar;
